var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAzureinline = function SvgAzureinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure_inline_svg__a)",
    d: "M16.334 2.5h13.612l-14.13 41.535a2.156 2.156 0 0 1-.79 1.06 2.183 2.183 0 0 1-1.266.404H3.167a2.18 2.18 0 0 1-1.76-.896 2.14 2.14 0 0 1-.293-1.94L14.278 3.964c.145-.427.422-.798.79-1.06a2.181 2.181 0 0 1 1.266-.404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M36.12 30.36H14.534a1.005 1.005 0 0 0-.93.627.984.984 0 0 0 .248 1.088l13.87 12.843a2.19 2.19 0 0 0 1.487.582h12.222l-5.313-15.14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure_inline_svg__b)",
    d: "M16.34 2.501a2.164 2.164 0 0 0-1.278.41c-.371.27-.646.649-.784 1.083L1.135 42.628a2.13 2.13 0 0 0 .269 1.962 2.16 2.16 0 0 0 1.774.91h10.866a2.33 2.33 0 0 0 1.096-.514c.313-.264.55-.606.687-.99l2.62-7.664 9.363 8.663c.392.322.885.5 1.394.505H41.38l-5.34-15.14-15.568.003L30 2.5H16.34Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure_inline_svg__c)",
    d: "M33.723 3.963a2.151 2.151 0 0 0-.79-1.059 2.178 2.178 0 0 0-1.264-.403H16.5c.453 0 .895.141 1.264.403.368.263.644.633.79 1.06l13.164 38.698a2.133 2.133 0 0 1-.293 1.942 2.18 2.18 0 0 1-1.76.896h15.17a2.18 2.18 0 0 0 1.76-.897 2.14 2.14 0 0 0 .293-1.94l-13.165-38.7Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure_inline_svg__a",
    x1: 21.295,
    x2: 7.36,
    y1: 5.687,
    y2: 47.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure_inline_svg__b",
    x1: 25.716,
    x2: 22.451,
    y1: 24.995,
    y2: 26.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure_inline_svg__c",
    x1: 23.916,
    x2: 39.218,
    y1: 4.479,
    y2: 45.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
};
export default SvgAzureinline;